module.exports = __webpack_public_path__ + "images/emoji/metro.826769ff474ecc24e743.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/metro.png
// module id = 9Xg4
// module chunks = 1